import { CenterFlexRow, FlexColumn } from "styles/layout";
import { BAN_ICON_SRC } from "theme";
import { BannedTrackName } from "../styles";
import {
  BansText,
  BanIcon,
  TrackStatsCenterCell,
  BannedTrackNameCell,
} from "./styles";
import { selectTrackNameFromTournamentId } from "selectors/Tournament";
import { useAppSelector } from "app/hooks";

interface Props {
  teamOneBanTrackIds: string[];
  teamTwoBanTrackIds: string[];
  tournamentId: string;
}

export const H2HTrackBasedBans = ({
  teamOneBanTrackIds,
  teamTwoBanTrackIds,
  tournamentId,
}: Props) => {
  const teamOneTrackNames = useAppSelector((state) =>
    teamOneBanTrackIds.map((id) =>
      selectTrackNameFromTournamentId(state, id, tournamentId)
    )
  );
  const teamTwoTrackNames = useAppSelector((state) =>
    teamTwoBanTrackIds.map((id) =>
      selectTrackNameFromTournamentId(state, id, tournamentId)
    )
  );

  return (
    <table>
      <tbody>
        <tr>
          <BannedTrackNameCell leftAlign={false}>
            <FlexColumn style={{ alignItems: "flex-end" }}>
              {teamOneTrackNames.map((name, idx) => (
                <BannedTrackName key={`${idx}-${name}`}>{name}</BannedTrackName>
              ))}
            </FlexColumn>
          </BannedTrackNameCell>
          <TrackStatsCenterCell>
            <CenterFlexRow>
              <BanIcon src={BAN_ICON_SRC} />
              <BansText>Bans</BansText>
              <BanIcon src={BAN_ICON_SRC} />
            </CenterFlexRow>
          </TrackStatsCenterCell>
          <BannedTrackNameCell leftAlign={true}>
            <FlexColumn>
              {teamTwoTrackNames.map((name, idx) => (
                <BannedTrackName key={`${idx}-${name}`}>{name}</BannedTrackName>
              ))}
            </FlexColumn>
          </BannedTrackNameCell>
        </tr>
      </tbody>
    </table>
  );
};
